// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3iRxz","rootSuccess":"CompleteLink_rootSuccess__1px2e","rootFailure":"CompleteLink_rootFailure__2i0pk","isDisabled":"CompleteLink_isDisabled__1Mch_"};